if (!customElements.get('m-environment-video')) {
  class MEnvironmentVideo extends HTMLElement {
    constructor() {
      super();
      this.selectedIndex = 0;

      this.init();
    }

    init() {
      this.videoSection = this.querySelector('.video-section');
      this.videoElementWrapper = this.querySelector('.video-section__media');
      this.thumbnailsWrapper = this.querySelector('.slider__grid');
      this.thumbhails = this.querySelectorAll('.m-environment-video-thumbnail');

      this.thumbhails.forEach((thumbnail, index) => {
        thumbnail.addEventListener(
          'click',
          function () {
            thumbnail.classList.add('m-selected');
            setTimeout(() => {
              this.thumbhails[this.selectedIndex]?.classList.remove('m-selected');
              this.selectedIndex = index;
            }, 200);

            const thumbnailTemplate = thumbnail.querySelector('template').cloneNode(true);
            const thumbnailImageSrc = thumbnail.querySelector('img')?.src;
            const videoTemplate = this.videoElementWrapper.querySelector('template');
            const videoComponent = this.videoElementWrapper.querySelector('video-component');
            const mediaWrapper = this.videoElementWrapper.querySelector('deferred-media');
            const videoPoster = this.videoElementWrapper.querySelector('.media img');

            if (thumbnailTemplate) {
              videoTemplate?.remove();
              videoComponent?.remove();
              if (thumbnailImageSrc) {
                videoPoster.classList.remove('hidden');
                videoPoster.src = thumbnailImageSrc;
              } else {
                videoPoster.classList.add('hidden');
              }
              mediaWrapper.appendChild(thumbnailTemplate);
              mediaWrapper.removeAttribute('loaded');
              this.videoSection.classList.remove('video-section--played');
            }
          }.bind(this),
        );
      });
    }
  }

  customElements.define('m-environment-video', MEnvironmentVideo);
}
